import { func, number, shape, string } from 'prop-types';

export const IntegratedBrandBathPropTypes = {
  collection: shape({
    details: shape({}),
    metadata: shape({
      brandName: string,
      name: string,
      pageSize: number,
      productCount: shape({
        allProducts: string,
        inStore: string
      }),
      roomType: string,
      startIndex: number,
      type: string
    })
  }),
  collectionId: string.isRequired,
  storeId: string.isRequired
};
